/**
 * Copyright 2023 Design Barn Inc.
 */

import type { ImageOptionsV1 } from '../common';
import { LottieImageCommonV1 } from '../common';

export class LottieImageV1 extends LottieImageCommonV1 {
  public constructor(options: ImageOptionsV1) {
    super(options);
  }
}
